module.exports = __webpack_public_path__ + "img/help-activites.d75b4e36.jpg";